import { __assign, __rest } from "tslib";
import React from 'react';
import { useSelect } from 'downshift';
import classnames from 'classnames';
import './AccessibleSelect.scss';
import Icon from './Icon';
var AccessibleSelect = function (_a) {
    var _b;
    var className = _a.className, errorMessage = _a.errorMessage, _c = _a.inputWidth, inputWidth = _c === void 0 ? 'medium' : _c, _d = _a.isPinnedBottom, isPinnedBottom = _d === void 0 ? false : _d, _e = _a.isRequired, isRequired = _e === void 0 ? false : _e, label = _a.label, onBlur = _a.onBlur, onChange = _a.onChange, options = _a.options, placeholder = _a.placeholder, _f = _a.size, size = _f === void 0 ? 'medium' : _f, value = _a.value, props = __rest(_a, ["className", "errorMessage", "inputWidth", "isPinnedBottom", "isRequired", "label", "onBlur", "onChange", "options", "placeholder", "size", "value"]);
    // This modifies the onChange handler to be consistent with our
    // other implementations
    var handleChange = function (downshiftObj) {
        var _a;
        onChange((_a = downshiftObj.selectedItem) === null || _a === void 0 ? void 0 : _a.value);
    };
    var selectedItem = value
        ? options.find(function (item) { return item.value === value; })
        : null;
    var _g = useSelect({
        items: options,
        selectedItem: selectedItem,
        onSelectedItemChange: handleChange
    }), getItemProps = _g.getItemProps, getLabelProps = _g.getLabelProps, getMenuProps = _g.getMenuProps, getToggleButtonProps = _g.getToggleButtonProps, highlightedIndex = _g.highlightedIndex, isOpen = _g.isOpen;
    var containerClass = classnames('AccessibleSelect', "AccessibleSelect--".concat(inputWidth, "Width"), className);
    var labelClass = classnames('AccessibleSelect__label');
    var toggleButtonClass = classnames('AccessibleSelect__toggleButton', "AccessibleSelect__toggleButton--".concat(size), {
        'AccessibleSelect__toggleButton--hasPlaceholder': !selectedItem && placeholder
    });
    var listClass = classnames('AccessibleSelect__menu', {
        'AccessibleSelect__menu--isHidden': !isOpen,
        'AccessibleSelect__menu--isPinnedBottom': isPinnedBottom
    });
    var getItemClass = function (itemIndex, itemValue) {
        return classnames('AccessibleSelect__item', {
            'AccessibleSelect__item--isHighlighted': itemIndex === highlightedIndex,
            'AccessibleSelect__item--isSelected': itemValue === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value)
        });
    };
    return (React.createElement("div", __assign({}, props, { className: containerClass }),
        React.createElement("label", __assign({}, getLabelProps(), { className: labelClass }),
            isRequired ? React.createElement("span", { "aria-hidden": 'true' }, "* ") : null,
            label),
        React.createElement("div", __assign({}, getToggleButtonProps(), { "aria-required": isRequired, className: toggleButtonClass, onBlur: onBlur }),
            React.createElement("div", { className: 'AccessibleSelect__valueContainer' },
                React.createElement("div", null, (_b = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) !== null && _b !== void 0 ? _b : placeholder),
                React.createElement(Icon, { "aria-hidden": 'true', type: isOpen ? 'chevronUp' : 'chevronDown' }))),
        errorMessage ? (React.createElement("div", { className: 'AccessibleSelect__errorMessage', role: 'alert' }, errorMessage)) : null,
        React.createElement("ul", __assign({}, getMenuProps(), { className: listClass }), isOpen
            ? options.map(function (item, index) { return (React.createElement("li", __assign({ key: "".concat(item.value) }, getItemProps({ item: item, index: index }), { className: getItemClass(index, item.value) }), item.label)); })
            : null)));
};
export default AccessibleSelect;
//# sourceMappingURL=AccessibleSelect.js.map